module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Regular.7b8d1fa0.ttf";